export const marketSurveyJson = {
    // "title": "Market Survey",
    // "logoPosition": "right",
    "pages": [
        {
            "name": "page1",
            "elements": [
                {
                    "type": "dropdown",
                    "name": "selectDealer",
                    "title": "Select dealer",
                    "isRequired": true,
                    "choices": [
                        // {
                        //     "value": "Item 1",
                        //     "text": "Dealer 1"
                        // },
                        // {
                        //     "value": "Item 2",
                        //     "text": "Dealer 2"
                        // },
                        // {
                        //     "value": "Item 3",
                        //     "text": "Dealer 3"
                        // }
                    ],
                    "placeholder": "Select..."
                },
                {
                    "type": "radiogroup",
                    "name": "surveyFor",
                    "title": "Survey for ",
                    "isRequired": true,
                    "choices": [
                        {
                            "value": "Competitive Product",
                            "text": "Competitive Product"
                        },
                        {
                            "value": "Any New Product",
                            "text": "Any New Product"
                        }
                    ]
                },
                {
                    "type": "radiogroup",
                    "name": "selectFormType",
                    "title": "Select form type",
                    "isRequired": true,
                    "choices": [
                        {
                            "value": "Liquid",
                            "text": "Liquid"
                        },
                        {
                            "value": "Form",
                            "text": "Form"
                        }
                    ]
                },
                {
                    "type": "text",
                    "name": "companyName",
                    "title": "Enter company name",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "brandName",
                    "title": "Enter brand name",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "technicalName",
                    "title": "Enter technical name",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "marketSize",
                    "title": "Enter market size in KL/MT",
                    "description": "e.g. 100 kl  or 100 mt",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "directDealerPrice",
                    "title": "Enter direct dealer price per kg/lit with GST",
                    "description": " e.g. 100 kg or 100 lit",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "farmerPrice",
                    "title": "Enter farmer price per kg/lit with GST",
                    "description": " e.g. 80 kg or 80 lit",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "mrpEnter",
                    "title": "Enter MRP per kg/lit",
                    "description": "e.g 100 lit or 100 kg",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "schemaDetails",
                    "title": "Enter scheme details if applicable",
                    // "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "availablePackages",
                    "title": "Enter available packages",
                    "description": "e.g kg, gm, ml, lit, units etc\n",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "dosePerAcre",
                    "title": "Enter dose per acre",
                    "description": "e.g 1 kg, 1 lit etc",
                    "isRequired": true,
                    "placeholder": "Enter"
                },
                {
                    "type": "text",
                    "name": "quantitySold",
                    "title": " Enter quantity  Sold in MT/KL",
                    "description": "e.g 1 mt, 100 kl",
                    "isRequired": true,
                    "placeholder": "Enter"
                }
            ]
        }
    ],
    // "navigateToUrl": "https://stag-dms.agrocel.net/#/agrocel/dashboard",
    // "navigateToUrlOnCondition": [
    //     {}
    // ],
    "completeText": "Submit"
}